import { isEmpty } from 'lodash';
import { MobXProviderContext, observer } from 'mobx-react';
import * as React from 'react';
import { Header } from 'semantic-ui-react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { pushToGTMDataLayer } from 'Utils/analytics';
import { ChannelInfoViewProps } from './interface';

const ChannelInfoView = ({ conversation }: ChannelInfoViewProps) => {
  const { conversation: conversationStore } =
    React.useContext<RootStoreProps>(MobXProviderContext);

  React.useEffect(() => {
    pushToGTMDataLayer('channelInfoView', {
      conversationId: conversation.id,
    });
  }, []);

  React.useEffect(() => {
    if (conversation) {
      conversationStore.addProperName(conversation);
    }
  }, [conversation]);

  return (
    <div data-private className="channel-info-view">
      <Header as="h2" textAlign="center" className="no-vmargin">
        <Header.Content title={conversation.topic}>
          {conversation.topic}
        </Header.Content>
        {!isEmpty(conversation.description) && (
          <Header.Subheader title={conversation.description}>
            {conversation.description}
          </Header.Subheader>
        )}
      </Header>
    </div>
  );
};

export default observer(ChannelInfoView);
